import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import { signInWithEmailAndPassword } from "firebase/auth";
import { db, auth } from "../../firebase";
import UserCreateContext from "../Context/context";
import { collection, doc, getDoc } from "firebase/firestore";
const Login = () => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const userContext = useContext(UserCreateContext);

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [autherror, setAuthError] = useState(false);
  const [catcherror, setCatchError] = useState(false);

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setSubmitted(false);
    setAuthError(false);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
    setSubmitted(false);
    setAuthError(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email === "" || password === "") {
      setError(true);
    } else {
      signInWithEmailAndPassword(auth, email, password)
        .then(async (userCredentials) => {
          console.log(userCredentials);
          console.log(userCredentials.user);
          console.log(userCredentials.user.uid);
          setError(false);
          setAuthError(false);
          setSubmitted(true);
          console.log("We are loggin");
          navigate("/dial");

          const userColl = collection(db, "user");
          let userDoc = doc(userColl, userCredentials.user.uid);
          const onSnapshot = await getDoc(userDoc);
          if (onSnapshot.exists()) {
            let userInfo = onSnapshot.data();

            // Set user data in context
            userContext.setUserData(userInfo);
            setUsername(userInfo.name);
          } else {
            console.log("No such document!");
          }

          //Query
          // const q = query(
          //   userColl,
          //   where("id", "==", userCredentials.user.uid)
          // );

          // console.log("q : ", q);
          // const querySnapshot = await getDocs(q);
          // querySnapshot.forEach((doc) => {
          //   console.log("We had our query");
          //   // doc.data() is never undefined for query doc snapshots
          //   console.log(doc.id, " => ", doc.data());
          //   let d1 = doc.data();
          //   console.log("d1", d1);
          // });
        })
        .catch((lgnerr) => {
          // console.log(lgnerr);
          var lgec = lgnerr.code;
          console.log(lgec);
          setAuthError(true);
          switch (lgec) {
            case "auth/user-not-found": {
              console.log("Entered user  not found : ", lgec);
              setCatchError("Entered user  not found");
              break;
            }

            case "auth/wrong-password": {
              console.log("Entered password is wrong : ", lgec);
              setCatchError("Entered password is wrong");
              break;
            }

            case "auth/network-request-failed": {
              console.log("Network Lost ", lgec);
              setCatchError("NETWORK LOST : Connect to the Network");
              break;
            }

            default: {
              console.log("Something went wrong..", lgec);
              setCatchError("Something went wrong..");
              break;
            }
          }
        });
    }
  };

  const handleReset = () => {
    console.log("Resetbtn");
    setAuthError(false);
    setError(false);
    setSubmitted(false);
    setEmail("");
    setPassword("");
  };

  const successMessage = () => {
    console.log("username", username);
    return (
      <div
        className="success"
        style={{
          display: submitted ? "" : "none",
        }}
      >
        <h3>User {username}! You have been Logged In</h3>
      </div>
    );
  };

  const errorMessage = () => {
    console.log("error");
    return (
      <div
        className="error"
        style={{
          display: error ? "" : "none",
        }}
      >
        <h3>Please enter all the fields</h3>
      </div>
    );
  };
  const authErrorMessage = () => {
    // console.log(lgec);
    console.log("error in auth");
    return (
      <div
        className="autherror"
        style={{
          display: autherror ? "" : "none",
        }}
      >
        <h3>Auth error : {catcherror}</h3>
      </div>
    );
  };
  return (
    <>
      <div className="login">
        <div className="messages">
          {errorMessage()}
          {successMessage()}
          {authErrorMessage()}
        </div>
        <form action="" className="pg">
          <div>
            <h1 className="htxt">Login</h1>
          </div>
          <div className="items txtinp">
            <input
              type="email"
              onChange={handleEmail}
              className="inp"
              name="email"
              required
            ></input>
            <span className="txt">Email</span>
          </div>

          <div className="items txtinp">
            <input
              type="password"
              onChange={handlePassword}
              className="inp"
              name="pwd"
              required
            ></input>
            <span className="txt">Password</span>
          </div>

          <div className="items">
            <Link to="" className="links fp">
              Forgot Password?
            </Link>
          </div>

          <div className="items">
            <div className="fp fptxt">
              Don't have an Account?
              <Link to="/register" className="links">
                Sign Up
              </Link>
            </div>
          </div>

          <div className="items btncont">
            <button className="btn" onClick={handleSubmit}>
              Login
            </button>
            <button type="reset" onClick={handleReset} className="btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;
